import { apiBaseUrl } from './config';

// Export the API base URL
export const api = apiBaseUrl;
